module.exports = __webpack_public_path__ + "7a1ac083f32794ed1e0e2f478b9320a2.pdf";